import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import Grid from '@material-ui/core/Grid'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
// import SwipeableViews from 'react-swipeable-views'
import Paper from '@material-ui/core/Paper'
import PlanComponent from './PlanComponent'
import BarsComponent from './bar/BarsComponent'

function TabContainer({ className, children }) {
  return (
    <Grid className={className} item>
      {children}
    </Grid>
  )
}
TabContainer.propTypes = {
  className: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

const styles = theme => ({
  container: {
    borderRadius: '5px',
    overflow: 'hidden',
    height: 'calc(100%)',
    margin: 4
  },
  rootTabs: {
    width: '100%',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    height: 52
  },
  scrollContainer: {
    overflow: 'scroll',
    width: 'calc(100%)',
    height: 'calc(100% - 64px)'
  },
  rootTab: {
    height: 52,
    maxWidth: 'none'
  }
})
export default withRouter(
  withStyles(styles, { withTheme: true })(
    class HomeTabsComponent extends Component {
      static propTypes = {
        classes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        tabId: PropTypes.number,
        theme: PropTypes.object.isRequired,
        tables: PropTypes.array.isRequired,
        map: PropTypes.object.isRequired,
        currentPricing: PropTypes.object.isRequired,
        bars: PropTypes.array.isRequired,
        addSideTable: PropTypes.func.isRequired,
        createBar: PropTypes.func.isRequired
      }

      state = {
        value: 0
      }
      componentDidMount() {
        const { tabId } = this.props
        this.setState({ value: tabId || 0 })
      }
      componentWillReceiveProps(nextProps) {
        if (nextProps.tabId !== this.props.tabId) {
          this.setState({ value: nextProps.tabId || 0 })
        }
      }
      handleChange = (event, value) => {
        this.props.history.replace(`/home/${value}`)
      }
      render() {
        const { tables, bars, classes, theme, tabId } = this.props
        const { value } = this.state

        return (
          <Paper className={classes.container} elevation={3}>
            <Tabs
              className={classes.rootTabs}
              value={tabId}
              onChange={this.handleChange}
              fullWidth
              centered
              scrollButtons="off"
              indicatorColor="secondary">
              <Tab className={classes.rootTab} label="Billard" />
              <Tab className={classes.rootTab} label="Bar" />
              {/* <Tab className={classes.rootTab} label="Clients" /> */}
            </Tabs>
            {value === 0 && (
              <TabContainer className={classes.scrollContainer}>
                <PlanComponent
                  tables={tables}
                  addSideTable={this.props.addSideTable}
                  map={this.props.map}
                  currentPricing={this.props.currentPricing}
                />
              </TabContainer>
            )}
            {value === 1 && (
              <TabContainer className={classes.scrollContainer}>
                <BarsComponent bars={bars} createBar={this.props.createBar} />
              </TabContainer>
            )}
            {value === 2 && (
              <TabContainer dir={theme.direction}> Clients </TabContainer>
            )}
          </Paper>
        )
      }
    }
  )
)



// WEBPACK FOOTER //
// ./src/routes/Home/components/HomeTabsComponent.js